import { http } from '../axios';
import { shopPrefix } from '../../config';
import { SelectionList } from '../../../models/SelectionList';

export async function fetchSelectionLists() {
    const response = await http.get<SelectionList[]>(`${shopPrefix}/v1/selectionlists`);
    return response.data;
}
